import Vue from 'vue'
import toastr from '../toastr'
import VueMultiselect from 'vue-multiselect'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import textInput from '../../component/dccore-form/textInput.vue'
import numberInput from '../../component/dccore-form/numberInput.vue'
import timePicker from '../../component/timePicker.vue'
import mixins from '../mixins.js'
import bootbox from 'bootbox'
import History from './history.vue'

Vue.use(VueResource)

if ($('#default_form').length) {
  new Vue({
    el: '#default_form',
    components: {
      VueMultiselect,
      Singleselect,
      Multiselect,
      RingLoader,
      timePicker,
      textInput,
      numberInput,
      History
    },
    mixins: [mixins],
    data: {
      loading: 0,
      errors: {
        sunday: {},
        monday: {},
        tuesday: {},
        wednesday: {},
        thursday: {},
        friday: {},
        saturday: {}
      },
      form: {
        entity: {
          brand: null,
          sunday: {},
          monday: {},
          tuesday: {},
          wednesday: {},
          thursday: {},
          friday: {},
          saturday: {}
        }
      },
      days: {},
      brands: [],
      addressTypes: [],
      selectedBrand: null
    },
    watch: {
      'form.entity.brand': function () {
        this.getDays()
      }
    },
    mounted() {
      this.loading++

      this.getType()
      this.getBrands()
      this.getDays()

      this.loading--
    },
    methods: {
      updateDays() {
        this.loading++

        let url = Routing.generate('api_patch_days')
        let data = {
          data: Object.assign({}, this.form.entity)
        }
        let daysOfWeek = ['monday', 'tuesday', 'saturday', 'wednesday', 'thursday', 'friday', 'sunday']
        daysOfWeek.forEach(el => {
          delete data.data[el].addressTypeName
        })

        this.$http.patch(url, data).then(() => {
          this.errors = {
            sunday: {},
            monday: {},
            tuesday: {},
            wednesday: {},
            thursday: {},
            friday: {},
            saturday: {}
          }
          //if (redirect) {
          //    $(location).attr('href', Routing.generate('days_default', {brand: brandId}))
          //} else {
          toastr.success(Translator.trans('form.updated'))
          //}
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this)
          this.errors = Object.assign({
            sunday: {},
            monday: {},
            tuesday: {},
            wednesday: {},
            thursday: {},
            friday: {},
            saturday: {}
          }, this.errors)
        })

      },
      getDays() {
        if (this.form.entity.brand === null) {
          return
        }

        this.loading++

        let url = Routing.generate('api_get_days', { brand: this.form.entity.brand,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      checkTime(i) {
        if (i < 10) {
          i = `0${i}`
        }

        return i
      },
      getType() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'address_type',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.addressTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },

      history() {
        let url = Routing.generate('api_get_entity_logger_show_default_days',
          { brandId: this.form.entity.brand ? this.form.entity.brand : 0 })

        let dialog = bootbox.dialog({
          title: Translator.trans('entity_logger.modal_title'),
          message: `<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> ${Translator.trans('common.loading')} </p>`,
          backdrop: true,
          onEscape: true,
          className: 'history-modal',
          size: 'large',
          buttons: {
            cancel: {
              label: Translator.trans('common.close'),
              className: 'btn btn-default',
              callback: function () {
                dialog.modal('hide')
              }
            },
          }
        })

        dialog.init(() => {
          $.ajax({
            url: url,
            type: 'GET',
            success: function (result) {
              dialog.find('.bootbox-body').html(result)
            },
            error: function () {
              toastr.error(Translator.trans('global.messages.fetch_problem'))
            }
          })
        })
      }
    }
  })
}
